module.exports = __webpack_public_path__ + "static/nordic_8-74a04833b7602a2523788afcf577afd0.jpg";